import { render, staticRenderFns } from "./FactoringInformacionEventosFactoring.vue?vue&type=template&id=129540b8"
import script from "./FactoringInformacionEventosFactoring.vue?vue&type=script&lang=js"
export * from "./FactoringInformacionEventosFactoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports